module.exports = __webpack_public_path__ + "img/贝漾美天.493ef23.png";